import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { VideoComponent } from "./video-component.js";
const Video = ({
  settings,
  componentData,
  updateAttributes,
  node,
  editor
}) => {
  const { t } = useContext(RicosContext);
  const { loading, loadingPercentage, id } = node.attrs;
  return /* @__PURE__ */ React.createElement(
    VideoComponent,
    {
      componentData,
      t,
      config: settings,
      updateAttributes,
      isLoading: loading,
      loadingPercentage,
      nodeId: id,
      editor
    }
  );
};
export {
  Video
};
//# sourceMappingURL=component.js.map
